import { createApi } from "@reduxjs/toolkit/query/react";
import { getAxiosInstance } from "../../../api";

const axiosBaseQuery =
  () =>
  async ({ params, endpoint, method, body }) => {
    const api = await getAxiosInstance();
    const getParams = (key) => {
      if (params?.[key]) {
        return `${key}=${params[key]}&`;
      } else {
        return "";
      }
    };
    if (method === "get") {
      try {
        const response = await api[method](
          `${endpoint}?${getParams("receipt_id")}${getParams("end")}filter=${
            params?.filter || "all"
          }&${getParams("sort_by")}sort_order=${
            params?.sort_order || "asc"
          }&per_page=${params?.page_size || "10"}&${getParams("search")}page=${
            params?.page || 1
          }`,
          body
        );
        return { data: response.data };
      } catch (axiosError) {
        let err = axiosError;
        return {
          error: {
            status: err.response?.status,
            data: err.response?.data || err.message,
          },
        };
      }
    } else {
      try {
        const response = await api[method](
          `${endpoint}${getParams("start")}${getParams("end")}${getParams(
            "sort_by"
          )}${getParams("search")}`,
          body
        );
        return { data: response.data };
      } catch (axiosError) {
        let err = axiosError;
        return {
          error: {
            status: err.response?.status,
            data: err.response?.data || err.message,
          },
        };
      }
    }
  };

export const filterForm = createApi({
  reducerPath: "filterFormApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["filterForm"],
  endpoints: (builder) => ({

    getApprovedListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/filterForm/certificate-list`,
      }),
    }),
    //Common data for filter
    getFilterListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/filters/common-search-filters`,
      }),
    }),

    updateRlm1ReportData: builder.mutation({
        query: (body) => ({
          method: "post",
          body,
          endpoint: `/verification/pending-list`,
        }),
  
        invalidatesTags: ["verification"],
      }),
  
  }),
});

export const { useUpdateRlm1ReportDataMutation, useGetApprovedListDataQuery,useGetFilterListDataQuery } = filterForm;
